import {HttpResponse} from "@angular/common/http";
import {mergeMap, Observable, of, timer} from "rxjs";
import {JwtHttpClientService} from "../http/jwt-http-client.service";

/**
 * Base class with common methods for action, entity, report, and search services
 */
export abstract class ResourceService {

    /**
     * Static URL prefix for getting a pending process result
     * @type {string}
     */
    public static readonly URL_PENDING_PREFIX: string = '/dataserver/entity/pendingProcess/';

    protected constructor(protected http: JwtHttpClientService,
                          protected nameSpace: string,
                          protected resource: string) {
    }

    public getNameSpace(): string {
        return this.nameSpace;
    }

    public getResource(): string {
        return this.resource;
    }

    protected handleAsync(serviceObservable: Observable<HttpResponse<Object>>, responseType: "json" | "blob" | "text" = "json"): Observable<HttpResponse<Object | Blob | string>> {
        return serviceObservable.pipe(
            mergeMap((response: HttpResponse<Object>) => response.status === 202 && response.headers.has("processId") ? this.getAsyncProcessResponse(response.headers.get("processId"), responseType) : of(response))
        );
    }

    protected getAsyncProcessResponse(processId: string, responseType: "json" | "blob" | "text" = "json"): Observable<HttpResponse<Object | Blob | string>> {
        return timer(5000).pipe(
            mergeMap(() => this.http.get(ResourceService.URL_PENDING_PREFIX + processId, undefined, undefined, responseType)),
            mergeMap((response: HttpResponse<Object>) => response.status === 202 ? this.getAsyncProcessResponse(processId, responseType) : of(response))
        );
    }
}
